<main class="container row mt-6 justify-content-center is-margin-auto">
  <div class="col-md-8 text-center">
    <img class="img-fluid" alt="404" src="/assets/images/not-found.svg">
    <p class="mt-3 h2 text-uppercase font-weight-bold text-danger">Página no encontrada</p>
    <p>La página que estás buscando fue movida, eliminada o puede que nunca haya existido.</p>
    <button class="btn btn-primary" routerLink="/dashboard">Ir al inicio</button>
  </div>
</main>
